<template>
  <!-- <div
    v-if="limit === maxPresetAllow"
    class="absolute -top-1 left-1 translate-y-[-100%] w-[258px]"
  >
    <p class="bg-tooltip !px-1 !pt-1 !pb-[10px] rounded text-white leading-[18px] font-medium text-xs">
      You've reached the maximum number of Global Style presets (20/20). Try deleting other presets to create a new one.
    </p>
    <div class="w-0 h-0 border-l-4 border-r-4 border-t-4 border-tooltip border border-b-0 border-l-transparent border-r-transparent translate-x-[125px]" />
  </div> -->
  <div class="gf_upgrade-plan--popup">
    <div class="gf_upgrade-plan--container">
      <div class="gf_upgrade-plan--alert">{{ planAlert }}</div>
      <a
        v-if="showSeePlan"
        :data-href="pricingUrl"
        target="_blank"
        class="gf_upgrade-plan--see-plan-button gp-open-new-tab"
        >See Plan</a
      >
    </div>
    <div class="gf_upgrade-plan--after">
      <svg
        class="gf_upgrade-plan--down-arrow"
        width="16"
        height="8"
        viewBox="0 0 16 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0L8 0L16 0L8.70711 7.29289C8.31658 7.68342 7.68342 7.68342 7.29289 7.29289L0 0Z" fill="#323232" />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { PRICING_LIMIT_PRESET } from '../../constants/global-style';
import goToPricing from '@/mixins/goToPricing';

export default {
  name: 'UpgradePlanPopup',
  mixins: [goToPricing],
  props: {
    limit: Number,
  },
  data() {
    return {
      maxPresetAllow: PRICING_LIMIT_PRESET.advanced,
    };
  },
  computed: {
    ...mapState('app', {
      shopInfo: 'shopInfo',
    }),
    planAlert() {
      return this.$t(
        `sidebarGS.listPreset.limitPresetAlert.${this.shopInfo?.plan}`,
      );
    },
    showSeePlan() {
      const plan = this.shopInfo?.plan;
      return !!(plan !== 'advanced' && plan !== 'optimize');
    },
  },
};
</script>

<style lang="scss" scoped>
.gf_upgrade-plan {
  &--popup {
    position: absolute;
    top: 0;
    width: 294px;
    transform: translate(0, -100%);
    z-index: 10;
  }

  &--container {
    filter: drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.25)) drop-shadow(0px -4px 16px rgba(0, 0, 0, 0.06));
    background: #323232;
    border-radius: 3px;
    padding: 16px;
  }

  &--after {
    display: flex;
    justify-content: center;
  }

  &--down-arrow {
    display: inherit;
  }

  &--alert {
    color: #e2e2e2;
    text-align: center;
    font-size: 14px;
    line-height: 150%;
  }

  &--see-plan-button {
    margin-top: 16px;
    text-align: center;
    background: #3c67ff;
    border-radius: 3px;
    color: #ffffff;
    width: 100%;
    display: block;
    font-weight: 500;
    padding: 9px;

    &:hover {
      background: #2856f8;
    }
  }
}
</style>
